var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpToLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.625 342.625L160 269.25V448C160 465.688 174.312 480 192 480S224 465.688 224 448V269.25L297.375 342.625C303.625 348.875 311.812 352 320 352S336.375 348.875 342.625 342.625C355.125 330.125 355.125 309.875 342.625 297.375L214.625 169.375C202.125 156.875 181.875 156.875 169.375 169.375L41.375 297.375C28.875 309.875 28.875 330.125 41.375 342.625S74.125 355.125 86.625 342.625ZM32 96H352C369.688 96 384 81.688 384 64S369.688 32 352 32H32C14.312 32 0 46.312 0 64S14.312 96 32 96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpToLine);
export default __webpack_public_path__ + "static/media/arrow-up-to-line.0479033392b95063eb2fa4f94bd83746.svg";
export { ForwardRef as ReactComponent };